import { render, staticRenderFns } from "./PackageSetup.vue?vue&type=template&id=fa5fb8d8&scoped=true"
import script from "./PackageSetup.vue?vue&type=script&lang=js"
export * from "./PackageSetup.vue?vue&type=script&lang=js"
import style0 from "./PackageSetup.vue?vue&type=style&index=0&id=fa5fb8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5fb8d8",
  null
  
)

export default component.exports